export default {
    'diagram4-1-1': {
        's': 'S = When the sun fails, humans will turn to the energy of the visible universe.',
        's-a': 'S = X will happen',
        'c': 'C = When they exhaust that, the only remaining store of energy will be in black holes',
        'c-a': 'C = Will require Y action',
        'q': 'Q = Might they be able to harvest this energy and save civilization?',
        'q-a': 'Q = Can they do it?',
        'a': 'A = Yes, if they had a space elevator, but that defies the laws of physics',
        'a-a': 'A= (Yes, if. . .)',
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/4/4a/diagram1/i18n/en.js